import { SwapKitApi } from "@swapkit/api";

export async function getPricesByToken() {
  const tokenPrices = await SwapKitApi.getCachedPrices({
    tokens: [
      { identifier: "THOR.RUNE" },
      { identifier: "ETH.COINBT-0x6fa5e1c43b5a466cbd1cae7993b67c982400d481" },
    ],
  });

  return {
    RUNE: tokenPrices?.[0]?.price_usd || 0,
    COINBT: tokenPrices?.[1]?.price_usd || 0,
  };
}
